export const sessionRecordUrls = () => {
    return [
        { url: '/', chance: 0.1 },
        { url: '/energie/start-vergelijken', chance: 0.1 },
        { url: '/persoonlijk-aanbod*', chance: 1 },
        { url: '/lp/energie-vergelijken-met-vvv-cadeaubon', chance: 1 },
    ];
}